import type { CanvasCollaborators } from '@confluence/team-presence/entry-points/presenceTypes.ts';

import { ContentTypesActionsService } from './content-types-actions-service.ts';

export const contentCollaboratorsService: ContentTypesActionsService<CanvasCollaborators> =
	new ContentTypesActionsService<CanvasCollaborators>();
